import React from 'react';
import styles from './OldTipPublishPopup.module.scss';
import { NavLink } from 'react-router-dom';
/* Router */
import { RouteComponentProps, withRouter } from 'react-router';
//tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../../utils/translations/translator';

/* Assets */
import SVG from 'react-inlinesvg';
import close from '../../../assets/icons/close.svg';
import { RootState } from '../../../store';
import { connect } from 'react-redux';
import { LoginState } from '../../../store/login/reducer';
import { Credentials } from '../../../types/Login';
import defaultTipsterImage from '../../../assets/icons/ic_tipster_default.svg';
import { loginActions } from '../../../store/login/actions';
import { Dispatch } from 'redux';

interface TipPublishPopupProps extends RouteComponentProps {
  loginState: LoginState;
  onClose?: () => void;
}
interface DispatchProps {
  requestLogout: () => void;
}

export const OldTipPublishPopup: React.FC<
  TipPublishPopupProps & DispatchProps
> = ({ onClose = null, loginState, requestLogout }) => {
  const { t } = useTranslation();
  const user: Credentials | null = loginState.user ? loginState.user : null;
  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <div className={styles.header}>
          <label>{tr(t, 'tip-publish-popup_header')}</label>
          {onClose && (
            <div className={styles.close} onClick={onClose}>
              <SVG src={close} />
            </div>
          )}
        </div>
        <div>
          <div className={styles.btnWrapper}>
            <NavLink to={'/betPublish/simple'} className={styles.formBtn}>
              <div onClick={onClose ? onClose : () => {}}>
                <p>{tr(t, 'single-bet')}</p>
              </div>
            </NavLink>
            <NavLink to={'/betPublish/combined'} className={styles.formBtn}>
              <div onClick={onClose ? onClose : () => {}}>
                <p>{tr(t, 'combined-bet')}</p>
              </div>
            </NavLink>
          </div>
        </div>

        {user && !onClose && (
          <div className={styles.tipsterAvatarWrapper}>
            <img
              src={user.user.avatar_url || defaultTipsterImage}
              className={styles.avatar}
              alt="user profile pic"
            />
            <div>
              <p>{user.user.username}</p>
            </div>
            <div className={styles.logoutBtn}>
              <button onClick={requestLogout}>Logout</button>
            </div>
          </div>
        )}
      </div>
      <div className={styles.overlay}></div>
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  loginState: state.login,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  requestLogout: () => {
    dispatch(loginActions.logoutRequestAction());
  },
});

export const OldTipPublishPopupConnected = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OldTipPublishPopup),
);
